<div class="settings-box" *ngIf="newsletterControl">
  <div class="settings-box__header">
    <h2 class="settings-box__title">
      {{
        content?.fields?.resources
          | findResource: 'settings.communicationsTitle'
      }}
    </h2>
  </div>

  <div>
    <div class="newsletter-container">
      <div class="newsletter-switch-container">
        <app-checkbox
          [field]="newsletterField"
          [control]="newsletterControl"
        ></app-checkbox>
      </div>
      <p>
        {{
          content?.fields?.resources
            | findResource: 'settings.monthlyNewsletter'
        }}
      </p>
    </div>
  </div>
</div>
